import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, theme } from "antd";
import { __, _i } from "../../../../utils/i18n.js";
const VISIBLE_HOSTNAMES_LIMIT = 5;
const ExpiredPaymentMoreSitesTooltip = ({ overflow, children })=>/*#__PURE__*/ _jsx(Tooltip, {
        title: overflow.join(", "),
        children: /*#__PURE__*/ _jsx("span", {
            className: "rc-account-v2-expired-payment-form__more",
            tabIndex: 0,
            children: children
        })
    });
const joinHostnamesWithAnd = (items)=>{
    if (items.length === 1) {
        return items[0];
    }
    return __("%s and %s", items.slice(0, -1).join(", "), items[items.length - 1]);
};
const ExpiredPaymentAffectedSites = ({ productName, hostnames })=>{
    const { token } = theme.useToken();
    if (hostnames.length === 0) {
        return null;
    }
    const visible = hostnames.slice(0, VISIBLE_HOSTNAMES_LIMIT);
    const overflow = hostnames.slice(VISIBLE_HOSTNAMES_LIMIT);
    if (overflow.length === 0) {
        return /*#__PURE__*/ _jsx("p", {
            className: "rc-account-v2-expired-payment-form__affected",
            style: {
                color: token.colorText
            },
            children: __("Your %s subscription is currently active on %s.", productName, joinHostnamesWithAnd(visible))
        });
    }
    const visibleJoined = visible.join(", ");
    const overflowSentence = overflow.length === 1 ? __("Your %s subscription is currently active on %s and {{more}}1 more website{{/more}}.", productName, visibleJoined) : __("Your %s subscription is currently active on %s and {{more}}%d more websites{{/more}}.", productName, visibleJoined, overflow.length);
    return /*#__PURE__*/ _jsx("p", {
        className: "rc-account-v2-expired-payment-form__affected",
        style: {
            color: token.colorText
        },
        children: _i(overflowSentence, {
            more: /*#__PURE__*/ _jsx(ExpiredPaymentMoreSitesTooltip, {
                overflow: overflow
            })
        })
    });
};
export { ExpiredPaymentAffectedSites };
